import PropTypes from 'prop-types';
import FormCard, { FormCardStatusTypes } from 'Shared/components/cards/form-card/form-card';
import Textarea from 'Shared/components/textarea';
import styles from './text-form-card.css';


const TEXT_KIND = 'Text';


const TextFormCard = ({
  languageCode,
  questionId,
  valid,
  disabled,
  headerTexts,
  answer,
  onAnswerChange,
  className,
}) => {
  const handleAnswerChanged = (event) => onAnswerChange(questionId, TEXT_KIND, event.target.value);

  return (
    <FormCard
      status={valid ? FormCardStatusTypes.VALID : FormCardStatusTypes.INVALID}
      header={headerTexts[languageCode]}
      className={className}
      content={(
        <Textarea
          value={answer}
          onChange={handleAnswerChanged}
          disabled={disabled}
          className={styles.inputContainer}
        />
      )}
    />
  );
};

TextFormCard.propTypes = {
  languageCode: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  headerTexts: PropTypes.object.isRequired,
  answer: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TextFormCard;
